<template>
<el-tabs v-model="tabName" type="card">
  <!-- <el-tab-pane label="任务明细" name="toPro">
  <el-table class="tb-c-head" :data="Dts" border>
    <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
    <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
    <el-table-column label="模具编号" prop="MouldNo" min-width="120" show-overflow-tooltip />
    <el-table-column label="模具名称" prop="MouldName" min-width="120" />
    <el-table-column label="模数" prop="Quantity" min-width="70" />
    <el-table-column label="排产模数" prop="ThisPlanQuantity" width="80" />
    <el-table-column label="已报工数" prop="ThisReportQuantity" width="90" />
    <el-table-column label="完成率（%）" prop="CompletionRate" width="100" />
  </el-table></el-tab-pane> -->
  <el-tab-pane label="报工明细" name="report">
    <!-- 报工时间，报工单重，合格重量，合格数量、不合格重量，不合格数量，明细 -->
    <el-table class="tb-c-head" :data="ReportDts" border>    
    <el-table-column label="报工时间" prop="AddTime" />
    <el-table-column label="报工单重" prop="Grammage" />
    <el-table-column label="合格重量(kg)" prop="PassQuantity2" />
    <el-table-column label="合格数量" prop="PassQuantity" />
    <el-table-column label="不合格重量(kg)" prop="FailQuantity2" />
    <el-table-column label="不合格数量" prop="FailQuantity" />
    <el-table-column label="操作">
      <template slot-scope="{row}">
        <el-button type="text" @click="detail(row)">明细</el-button>
      </template>
    </el-table-column>
  </el-table>
  </el-tab-pane>
</el-tabs>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default:() => {}
    },
    repData: {
      type: Array,
      default:() => {}
    }
  },
  data() {
    return {
      api: require("@/api/sy/user").default,
      Dts: [],
      ReportDts:[],
      tabName:'report'
    };
  },
  methods: {
    setData(id) {
      console.log("setData", id);
      this.api.info(id).then((res) => {
        if (res.Code == 0) this.Dts = res.Data.Dts;
      });
    },
    clear() {
      this.Dts = [];
      this.ReportDts=[];
    },
    detail(row){},
  },
  watch: {
    data: {
      handler: function(newVal) {
        this.Dts = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true
    },
    repData: {
      handler: function(newVal) {
        console.log(newVal,"repData")
        this.ReportDts = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true
    }
  }
};
</script>